export const FETCH_MOST_POPULAR_SITES_SUCCESS = 'fetchMostPopularSitesSuccess';
export const UPDATE_ACTIVE_SORT_FIELD_MOST_POPULAR_SITES_M = 'updateActiveSortFieldMostPopularSitesMutation';
export const UPDATE_SEARCH_MOST_POPULAR_SITES_M = 'updateSearchMostPopularSitesMutation';
export const CLEAR_SEARCH_MOST_POPULAR_SITES_M = 'clearSearchMostPopularSitesMutation';
